import React, { useState } from 'react';
import { useQuote } from '../context/QuoteContext';
import { useToast } from '../hooks/useToast';
import Toast from './Toast';
import { services } from '../data/siteData';
import './QuoteForm.css';

const BUDGETS = ['Under ₹50,000', '₹50,000 – ₹1,50,000', '₹1,50,000 – ₹5,00,000', '₹5,00,000+', 'Not sure yet'];
const TIMELINES = ['ASAP', '1–3 months', '3–6 months', '6+ months', 'Flexible'];

function validate(form) {
  const errors = {};
  if (!form.name.trim())    errors.name    = 'Name is required.';
  if (!form.email.trim())   errors.email   = 'Email is required.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = 'Enter a valid email.';
  if (!form.service)        errors.service = 'Please select a service.';
  if (!form.message.trim()) errors.message = 'Please describe your project.';
  return errors;
}

export default function QuoteForm({ prefill = {} }) {
  const { submitQuote } = useQuote();
  const { toasts, toast } = useToast();
  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '',
    service: prefill.service || '',
    budget: '', timeline: '', message: '', ...prefill,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErrors(e => ({ ...e, [k]: '' })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    await new Promise(r => setTimeout(r, 800)); // simulate async
    const q = submitQuote(form);
    setLoading(false);
    setSubmitted(q);
    toast('Quote submitted! We\'ll be in touch within 24 hours.', 'success');
  };

  if (submitted) return (
    <div className="quote-success">
      <div className="qs-icon">✓</div>
      <h3>Request received!</h3>
      <p>Your quote ID is <strong>{submitted.id}</strong>. We'll respond within 24 hours.</p>
      <div className="qs-details">
        <div className="qs-row"><span>Name</span><strong>{submitted.name}</strong></div>
        <div className="qs-row"><span>Email</span><strong>{submitted.email}</strong></div>
        <div className="qs-row"><span>Service</span><strong>{submitted.service}</strong></div>
        <div className="qs-row"><span>Status</span><span className="status-badge pending">{submitted.status}</span></div>
      </div>
      <button className="btn-grad" style={{ marginTop: 20 }} onClick={() => setSubmitted(null)}>Submit another request</button>
    </div>
  );

  return (
    <>
      <Toast toasts={toasts} />
      <form className="quote-form" onSubmit={handleSubmit} noValidate>
        <div className="qf-row">
          <div className="fg">
            <label>Full Name *</label>
            <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="Ravi Kumar" className={errors.name ? 'error' : ''} />
            {errors.name && <div className="field-error">{errors.name}</div>}
          </div>
          <div className="fg">
            <label>Work Email *</label>
            <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="ravi@company.com" className={errors.email ? 'error' : ''} />
            {errors.email && <div className="field-error">{errors.email}</div>}
          </div>
        </div>
        <div className="qf-row">
          <div className="fg">
            <label>Phone / WhatsApp</label>
            <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91 98765 43210" />
          </div>
          <div className="fg">
            <label>Company</label>
            <input value={form.company} onChange={e => set('company', e.target.value)} placeholder="Your company name" />
          </div>
        </div>
        <div className="qf-row">
          <div className="fg">
            <label>Service Required *</label>
            <select value={form.service} onChange={e => set('service', e.target.value)} className={errors.service ? 'error' : ''}>
              <option value="">Select a service…</option>
              {services.map(s => <option key={s.id} value={s.title}>{s.title}</option>)}
              <option value="Full-Stack Project">Full-Stack Project</option>
              <option value="Other">Other / Not sure</option>
            </select>
            {errors.service && <div className="field-error">{errors.service}</div>}
          </div>
          <div className="fg">
            <label>Budget Range</label>
            <select value={form.budget} onChange={e => set('budget', e.target.value)}>
              <option value="">Select budget…</option>
              {BUDGETS.map(b => <option key={b}>{b}</option>)}
            </select>
          </div>
        </div>
        <div className="fg">
          <label>Preferred Timeline</label>
          <div className="timeline-chips">
            {TIMELINES.map(t => (
              <button type="button" key={t} className={`timeline-chip${form.timeline === t ? ' active' : ''}`} onClick={() => set('timeline', t)}>{t}</button>
            ))}
          </div>
        </div>
        <div className="fg">
          <label>Project Brief *</label>
          <textarea value={form.message} onChange={e => set('message', e.target.value)} placeholder="What are you building? What's the goal? Any tech preferences or constraints?" rows={5} className={errors.message ? 'error' : ''} />
          {errors.message && <div className="field-error">{errors.message}</div>}
        </div>
        <button type="submit" className="btn-grad qf-submit" disabled={loading}>
          {loading ? <><span className="spinner" /> Sending…</> : 'Send my request →'}
        </button>
        <p className="qf-note">We respond within 24 hours. No spam, no lock-in.</p>
      </form>
    </>
  );
}
